<button class="btn btn-primary mb-3" (click)="addRental()">Add Rental</button>

    <div *ngFor="let rental of rentals" class="card mb-3 p-3">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h5>{{ rental.title }}</h5>
          <p>{{ rental.address }}</p>
          <p>${{ rental.price }} / month</p>
        </div>
        <div>
          <button class="btn btn-sm btn-outline-primary me-2" (click)="editRental(rental.id)">Edit</button>
          <button class="btn btn-sm btn-outline-danger" (click)="deleteRental(rental.id)">Delete</button>
        </div>
      </div>
    </div>